import DeclarationQuestion from 'models/common/form/question/DeclarationQuestion';

export default class DeclarationQuestionService {
	toModel(question) {
		return new DeclarationQuestion(question);
	}
}
